<template>
    <van-popup
        v-if="selectClockRecordPopupShow"
        :value="selectClockRecordPopupShow"
        z-index="100"
        :close-on-click-overlay="false"
        :style="{ height: '100vh', width: '100vw', background: 'rgba(0,0,0,.3)' }"
        overlay-class="custom_popup"
        position="right"
    >
        <div class="select_clock_record_wrap" v-loading="loading">
            <div class="select_clock_record_top">
                <div class="returnNavBar">
                    <div class="returnNavBarLeft" @click="handleClickClose">
                        <van-icon name="arrow-left" />
                        <span class="normal_title">返回</span>
                    </div>
                </div>
                <div class="search_wrap">
                    <van-search
                        v-model="searchForm.keyword"
                        placeholder="请搜索打卡地址"
                        @clear="handleClickSearch"
                        @search="handleClickSearch"
                    >
                        <template #right-icon>
                            <i class="iconfont icon-rili" @click="calendarShow = true"></i>
                        </template>
                    </van-search>
                </div>
            </div>
            <div class="select_order_bottom">
                <van-checkbox-group v-model="selectionIds">
                    <ul v-infinite-scroll="onLoadList">
                        <li v-for="row in clockRecordData" :key="row.id">
                            <van-checkbox
                                icon-size="16px"
                                :name="row.id"
                                @click="handleChangeCheck(row)"
                                shape="square"
                            ></van-checkbox>
                            <div class="list_item_field">
                                <div class="field_item">
                                    <i class="iconfont icon-shijian"></i>
                                    <span v-if="row.punch_type == 'SINGLE'" class="field_value bold_text">{{
                                        row.created_at
                                    }}</span>
                                    <span v-else class="field_value bold_text"
                                        >{{ row.start_time }}~{{ row.end_time }}</span
                                    >
                                </div>
                                <div class="field_item">
                                    <i class="iconfont icon-weizhi1"></i>
                                    <span class="field_value">{{ row.address }}</span>
                                </div>
                            </div>
                            <span class="link-label">详情</span>
                        </li>
                    </ul>
                </van-checkbox-group>
            </div>
            <div class="select_order_btn">
                <van-button @click="handleClickConfirm" :disabled="btnDisabled" type="info" size="small"
                    >确定</van-button
                >
            </div>
            <van-popup
                v-model="calendarShow"
                :close-on-click-overlay="true"
                :style="{ height: '70vh', background: '#F7F8FA' }"
                position="bottom"
                round
                @click-overlay="handleClickPopupRangeCalendarClose"
            >
                <van-calendar
                    :allow-same-day="true"
                    :max-date="dateCalendarMax"
                    :min-date="dateCalendarMin"
                    :default-date="defaultDate"
                    :poppable="false"
                    :show-confirm="true"
                    :show-title="false"
                    color="#1990FF"
                    type="range"
                    @confirm="handleClickRangeCalendarConfirm"
                ></van-calendar>
            </van-popup>
        </div>
    </van-popup>
</template>
<script>
import { GetRelatecheckRecord } from "@/api";
import { pagination } from "@/mixins";
import { formatDate } from "@/utils";
export default {
    name: "ClockInRecordSelect",
    props: {
        selectClockRecordPopupShow: {
            type: Boolean,
            default: false,
        },
        selectData: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            loading: false,
            searchForm: {
                keyword: "",
                calc_date: [],
            },
            clockRecordData: [],
            selectionIds: [], //选中的id
            multipleSelection: [], //选中的数据

            calendarShow: false,
            dateCalendarMin: new Date("2015-01-01"),
            dateCalendarMax: new Date(new Date().setFullYear(new Date().getFullYear() + 5)),
            defaultDate: [],
            btnDisabled: false,
        };
    },
    mixins: [pagination],
    created() {
        this.multipleSelection = JSON.parse(JSON.stringify(this.selectData));
        this.selectionIds = this.multipleSelection.map((item) => item.id);
        this.getTableData();
    },
    methods: {
        handleClickClose() {
            this.$emit("update:selectClockRecordPopupShow", false);
        },
        handleChangeCheck(item) {
            if (this.selectionIds.includes(item.id)) {
                this.multipleSelection.push(item);
            } else {
                this.multipleSelection.splice(
                    this.multipleSelection.findIndex((item) => item.id == item.id),
                    1
                );
            }
        },
        // 选择日期
        handleClickRangeCalendarConfirm(range) {
            const [start, end] = range;
            let value = [formatDate(start, "date"), formatDate(end, "date")];
            this.searchForm.calc_date = value;
            this.calendarShow = false;
            this.handleClickSearch();
        },
        // 取消选择日期
        handleClickPopupRangeCalendarClose() {},
        handleClickSearch() {
            this.pagination.pageNum = 1;
            this.clockRecordData = [];
            this.getTableData();
        },
        onLoadList() {
            if (this.pagination.total == this.clockRecordData.length) {
                return false;
            }
            if (this.loading == false) {
                this.getTableData();
            }
        },
        getTableData() {
            this.loading = true;
            const params = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.searchForm.keyword,
                check_in_date: this.searchForm.calc_date,
            };
            GetRelatecheckRecord(params)
                .then((res) => {
                    if (res.code === 200) {
                        const { data, total } = res.data;
                        this.clockRecordData = this.clockRecordData.concat(data);
                        this.pagination.total = total;
                        this.pagination.pageNum++;
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        handleClickConfirm() {
            if (!this.multipleSelection || this.multipleSelection.length === 0)
                return this.$toast("请选择一条打卡记录");
            if (this.multipleSelection.length > 1) return this.$toast("最多关联一条打卡记录");
            this.$emit("success", this.multipleSelection);
            this.$emit("update:selectClockRecordPopupShow", false);
        },
    },
};
</script>
<style lang="scss" scoped>
.select_clock_record_wrap {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    position: relative;
    background: rgba(247, 248, 250, 1);

    .select_clock_record_top {
        width: 100%;
    }

    .search_wrap {
        width: 100%;

        .icon-rili {
            font-size: 14px;
            color: rgba(102, 102, 102, 1);
        }
    }

    .select_order_bottom {
        width: 100%;
        padding: 10px 16px;
        box-sizing: border-box;
        height: calc(100vh - 120px);
        overflow: auto;

        ul {
            width: 100%;

            li {
                width: 100%;
                padding: 8px 12px;
                border-radius: 6px;
                background: rgba(255, 255, 255, 1);
                margin-bottom: 10px;
                display: flex;
                .list_item_field {
                    flex: 1;
                    padding-left:12px;
                }
                ::v-deep .van-checkbox__icon {
                    .van-icon {
                        border-radius: 50%;
                    }
                }
            }
            .field_item {
                width: 100%;
                font-size: 14px;
                font-weight: 400;
                margin-bottom: 4px;
                line-height: 22px;
                display: flex;
                gap: 4px;
                &:last-child {
                    margin-bottom: 0;
                }

                ::v-deep .van-checkbox__icon {
                    .van-icon {
                        border-radius: 4px;
                    }
                }
                i {
                    font-size: 14px;
                    color: rgba(102, 102, 102, 1);
                    flex-shrink: 0;
                }

                .field_value {
                    color: rgba(102, 102, 102, 1);

                    &.bold_text {
                        font-weight: 700;
                        color: #333333;
                    }
                }
            }
        }
    }

    .select_order_btn {
        width: calc(100% - 32px);
        position: absolute;
        left: 16px;
        bottom: 16px;

        .van-button {
            width: 100%;
            height: 38px;
            border-radius: 6px;
        }
    }
}
</style>
